import { ODataSelect } from "../../../../Providers.Api/ODataQuery";

export class AdvancedVisitorType extends ODataSelect
{
    VisitorTypeId = "";
    Description = "";
    Icon = "";
    VisitorTypeWorkFlow = {
        Steps: [] as IStep[]
    };
    Node_Id = 0;
    Name = "";
    ConcurrencyStamp = "";
    OwnedByUserId = "";
    OwnedByRoleId = "";
    CreatedByUserId = "";
    ModifiedByUserId = "";
    TenancyId = "";

    override toSelect(): string
    {
        return ''
    }
}

export interface IStep
{
    Step: string,
    Description: string,
    Questions: IQuestion[]
}

export enum QuestionInputType {
    TrueFalse = 'QuestionTypeTrueFalse',
    Open = 'QuestionTypeOpen',
    Policy = 'QuestionTypePolicy',
    MultiOptionSingleSelect = 'QuestionTypeMultiOptionSingleSelect',
    Header = 'NonQuestionTypeHeader',
    SubHeader = 'NonQuestionTypeSubHeader',
    Image = 'NonQuestionTypeImage',
    }

export interface IQuestion
{
    Id: string,
    InputType: QuestionInputType,
    Name: string,
    HelperText: string,
    Value: string,
    goto: string,
    Required: boolean,
    MaxLength: string,
    PlaceHolderText: string,
    InputHeight: string,
    PolicyText: string,
    RequiredConfirmation: boolean,
    ConfirmationText: string,
    QuestionName: string,
    Labels: IMultiSelectLabelOption[],
    Answers: IAnswer[]
}

export interface IMultiSelectLabelOption
{
    Label: string,
    goto: string,
}

export interface IAnswer
{
    ModifiedBy: string,
    ModifiedAt: string,
    Value: string
}